var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,{tag:"component",staticClass:"text-fill position-relative w-100"},[_c('span',{ref:"placeholder",staticClass:"w-100 d-block"}),_vm._v(" "),_c('span',{ref:"headline",staticClass:"position-relative d-inline-block l-0 display-1 headline no-wrap",class:[_vm.innerClasses, { 
      'headline--top': _vm.top, 
      'headline--bottom': !_vm.top,
      'fade-out': !_vm.initialized
  }],style:(_vm.headlineStyle)},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.text)}}),_vm._v(" "),_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }